import { history } from "../helpers/history";
import { RequestWithAuthorization } from "../helpers/request";
import { actions as employerActions } from "../redux/ducks/employer";
import { redirectRoute } from "../config/routes";

const TOKEN_EMPLOYER_KEY = process.env.REACT_APP_TOKEN_EMPLOYER_KEY;

export const getEmployers = () => (dispatch) => {
  const request = new RequestWithAuthorization();
  request.get("/employers-client", (response) =>
    dispatch(employerActions.set(response))
  );
};

export const signInWithEmployer = (employerID) => {
  const request = new RequestWithAuthorization();
  request.get(`/login-with-employer?employerID=${employerID}`, (response) => {
    // it save employerToken in sessionStorage for persist the token when of page
    // is reloaded,  it saved in session for allow have a window per employer
    sessionStorage.setItem(TOKEN_EMPLOYER_KEY, response.token);

    if (history.location.pathname !== redirectRoute.privateEmployer) {
      history.push(redirectRoute.privateEmployer);
    }
  });
};
